<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>大模型管理</el-breadcrumb-item>
      <el-breadcrumb-item>使用记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width:300px;"
            @clear="getDMXRecList"
            @change="getDMXRecList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getDMXRecList"></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="4">
          <el-button type="primary" @click="openAddDialog">添加大模型</el-button>
        </el-col> -->
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="DMXRecList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label="UID" width="80"></el-table-column>
            <el-table-column prop="damoxing_name" label="名称"   width="100"></el-table-column>
            <!-- <el-table-column prop="damoxing_bianhao" label="编号"  ></el-table-column> -->
            <!-- <el-table-column prop="title" label="标题"  ></el-table-column> -->
            <el-table-column prop="content01" label="内容1"  ></el-table-column>
            <!-- <el-table-column prop="content02" label="内容2"  ></el-table-column> -->
            <!-- <el-table-column prop="content03" label="内容3"  ></el-table-column> -->
            <!-- <el-table-column prop="content04" label="内容4"  ></el-table-column> -->
            <el-table-column prop="jifen" label="消耗积分"  width="100" ></el-table-column>
            <el-table-column prop="add_time" label="时间"  width="200" ></el-table-column>
            <el-table-column label="操作"  width="100">
              <template v-slot="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  :enterable="false"
                  style="display:none"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="showEditDialog(scope.row.uid)"
                    circle
                    size="mini"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                  :enterable="false"
                >
                  <el-button
                    v-show="(scope.row.name !== 'admin')"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="mini"
                    @click="deleteForm(scope.row.uid)"
                  ></el-button>
                </el-tooltip>
                 
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum"
        :page-sizes="[10,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加大模型部分 -->
      <el-dialog title="添加大模型" :visible.sync="addDialogVisible" width="50%" @close="addDoalogClosed">
        <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <!-- <el-form-item label="选择角色" prop="juese_uid">
            <el-select
              v-model="addForm.juese_uid"
              placeholder="选择角色"
              @change="getJueseList"
            >
              <el-option
                v-for="item in jueseList"
                :key="item.uid"
                :label="item.juese_name"
                :value="item.uid"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="大模型编号" prop="bianhao">
            <el-input v-model="addForm.bianhao"></el-input>
          </el-form-item>
          <el-form-item label="大模型名称" prop="name">
            <el-input v-model="addForm.name"></el-input>
          </el-form-item>
          <el-form-item label="大模型账号" prop="zhanghao">
            <el-input v-model="addForm.zhanghao"></el-input>
          </el-form-item>
          <el-form-item label="大模型密码" prop="password">
            <el-input v-model="addForm.password"></el-input>
          </el-form-item>
          <el-form-item label="大模型路径" prop="path">
            <el-input v-model="addForm.path"></el-input>
          </el-form-item>
          <el-form-item label="Token" prop="token_DMXRec">
            <el-input v-model="addForm.token_DMXRec"></el-input>
          </el-form-item>
          <!-- <el-form-item label="联系手机号" prop="token_DMXRec">
            <el-input v-model="addForm.token_DMXRec" max="11" min="10"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addDMXRec">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改大模型信息 -->
      <el-dialog
        title="修改大模型信息"
        :visible.sync="editDialogVisible"
        width="50%"
        @close="editDoalogClosed"
      >
        <el-form ref="editFormRef" :model="addForm" :rules="editFormRules" label-width="100px">
          <!-- <el-form-item label="选择角色" prop="juese_uid">
            <el-select
              v-model="addForm.muyuan_chengshi_uid"
              placeholder="选择角色"
              @change="getJueseList"
            >
              <el-option
                v-for="item in jueseList"
                :key="item.uid"
                :label="item.juese_name"
                :value="item.uid"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="大模型编号" prop="bianhao">
            <el-input v-model="editForm.bianhao"></el-input>
          </el-form-item>
          <el-form-item label="大模型名称" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>
          <el-form-item label="大模型账号" prop="zhanghao">
            <el-input v-model="editForm.zhanghao"></el-input>
          </el-form-item>
          <el-form-item label="大模型密码" prop="password">
            <el-input v-model="editForm.password"></el-input>
          </el-form-item>
          <el-form-item label="大模型路径" prop="path">
            <el-input v-model="editForm.path"></el-input>
          </el-form-item>
          <el-form-item label="大模型Token" prop="token_DMXRec">
            <el-input v-model="editForm.token_DMXRec"></el-input>
          </el-form-item>
          <!-- <el-form-item label="联系手机号" prop="token_DMXRec">
            <el-input v-model="editForm.token_DMXRec" max="11" min="10"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateDMXRec" :disabled="add_isDisable">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 删除按钮是否可见
      // 获取大模型列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'damoxing_rec_list',
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      DMXRecList: [],
      // 用于下拉框的数据读取
      jueseList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'damoxing_add',
        bianhao: '',
        name: '',
        zhanghao: '',
        password: '',
        path: '',
        token_DMXRec: '99923423412412412341234123'
        // juese_uid: ''
      },
      // 用于修改数据绑定
      editForm: {},
      // 表单规则项
      addFormRules: {
        name: [
          { required: true, message: '请输入大模型名称', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到20位字符 ', trigger: 'blur' }
        ],
        token_DMXRec: [
          { required: true, message: '请输入token', trigger: 'blur' },
          { min: 20, max: 30, message: '必须是20-30位 ', trigger: 'blur' }
        ]
      },
      editFormRules: {}
    };
  },
  created() {
    this.getDMXRecList();
  },
  methods: {
    openAddDialog() {
         this.getJueseList()
         this.addDialogVisible = true
    },
    async getJueseList() {
      console.log(123)
       const { data: res } = await this.$http.get('get_api', {
        params: {
        C_table_name: 'DMXRec_juese_list', // 调用普通api get接口 2
        C_type: 'get_list',
        query: '',
        pageNum: 1,
        pageSize: 10
        }
      });
      console.log(res.data)
      this.jueseList = JSON.parse(res.data)[0].dataList
    },

    async getDMXRecList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
       console.log(JSON.parse(res.data))
      this.DMXRecList = JSON.parse(res.data)[0].dataList;

      if (!this.DMXRecList) return;
      this.DMXRecList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getDMXRecList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getDMXRecList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    addDMXRec() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return 1;
          this.add_isDisable = true
          setTimeout(() => {
           this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
       }, 2000)

        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.error('大模型名重复，添加失败');
          return;
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        this.$message.success('添加成功');
        this.getDMXRecList();
        this.addDialogVisible = false;
      });
    },
    showEditDialog(uid) {
      this.getJueseList()
      this.editDialogVisible = true;
      this.DMXRecInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    async DMXRecInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'damoxing_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }

      this.editForm = JSON.parse(res.data)[0].data[0];
    },
    async updateDMXRec() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return this.$message.error('验证错误！');
        const { data: res } = await this.$http.post('api', {
          C_type: 'damoxing_update',
          uid: this.editForm.uid,
          name: this.editForm.name,
          zhanghao: this.editForm.zhanghao,
          password: this.editForm.password,
          path: this.editForm.path,
          token_DMXRec: this.editForm.token_DMXRec
        });

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        this.$message.success('更新成功');
        this.getDMXRecList();
        this.editDialogVisible = false;
      });
    },
    // 删除一条记录
    async deleteForm(DMXRecUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'damoxing_rec_del',
        C_data1: DMXRecUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getDMXRecList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}
.el_row_two {
  margin-top: 30px;
}
</style>
